import React from 'react';
export function LeadSection() {
  return <section className="py-16 md:py-24 bg-white" data-id="element-61">
      <div className="container mx-auto px-4" data-id="element-62">
        <div className="max-w-3xl mx-auto prose prose-lg prose-slate" data-id="element-63">
          <p className="font-bold text-slate-900 text-xl md:text-2xl mb-8 border-l-4 border-red-600 pl-4 italic" data-id="element-64">
            "Son las 2 de la mañana. Escuchas una patrulla pasar frente a tu
            casa y, por un segundo, tu corazón se detiene."
          </p>

          <p data-id="element-65">
            Miras a tus hijos dormir y te asalta la pregunta que has estado
            ignorando:
          </p>

          <p className="font-bold text-red-700 text-xl" data-id="element-66">
            ¿Qué pasaría con ellos si mañana yo no cruzo esa puerta?
          </p>

          <p data-id="element-67">
            La mayoría de los inmigrantes en este país viven bajo la falsa
            creencia de que, por no tener un estatus legal definido, no tienen
            derechos sobre su futuro financiero o la custodia de sus hijos ante
            una emergencia.
          </p>

          <p className="bg-amber-50 p-4 border border-amber-200 rounded-lg text-slate-800 font-medium" data-id="element-68">
            Esa mentira es lo que destruye familias.
          </p>

          <p data-id="element-69">
            La verdad es que el sistema de Estados Unidos funciona con papeles,
            y si tú no has firmado los papeles correctos antes de la emergencia,
            el Estado decidirá por ti.
          </p>

          <ul className="list-none pl-0 space-y-2" data-id="element-70">
            <li className="flex items-center text-red-700 font-semibold" data-id="element-71">
              <span className="mr-2 text-2xl" data-id="element-72">×</span> Ellos decidirán quién se
              queda con tus hijos.
            </li>
            <li className="flex items-center text-red-700 font-semibold" data-id="element-73">
              <span className="mr-2 text-2xl" data-id="element-74">×</span> Ellos decidirán qué pasa
              con tu cuenta de banco.
            </li>
            <li className="flex items-center text-red-700 font-semibold" data-id="element-75">
              <span className="mr-2 text-2xl" data-id="element-76">×</span> Ellos decidirán tu
              futuro.
            </li>
          </ul>

          <p className="text-xl font-bold text-slate-900 mt-8" data-id="element-77">
            Hoy, voy a entregarte las llaves para que eso nunca pase. Te
            presento el Protocolo Sombrilla...
          </p>
        </div>
      </div>
    </section>;
}